// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".A8fvb3b_eeDfwPpiLcqz{position:fixed;top:0;left:0;height:100%;width:100%;opacity:.4;background-color:#000;z-index:1020}.ioHcZmpgn6zQ5Fo9KNZI{opacity:.8}", "",{"version":3,"sources":["webpack://./src/templates/overlay.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,KAAA,CACA,MAAA,CACA,WAAA,CACA,UAAA,CACA,UAAA,CACA,qBAAA,CACA,YAAA,CAGF,sBACE,UAAA","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0.4;\n  background-color: black;\n  z-index: 1020;\n}\n\n.minecraft {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": "A8fvb3b_eeDfwPpiLcqz",
	"minecraft": "ioHcZmpgn6zQ5Fo9KNZI"
};
export default ___CSS_LOADER_EXPORT___;
